import { subPaths } from "@bit/bit.utils.fs.sub-paths";

export function indexFileNames(fileList: string[]) {
	const allSubPaths = fileList.map(subPaths);
	const combinedPaths = ([] as string[]).concat(...allSubPaths);
	return new Set(combinedPaths);
}
